function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M320,208.02h-16v-32c0-35.296-28.704-64-64-64s-64,28.704-64,64v32h-16c-8.832,0-16,7.168-16,16v128 c0,8.832,7.168,16,16,16h160c8.832,0,16-7.168,16-16v-128C336,215.188,328.832,208.02,320,208.02z M208,176.02 c0-17.632,14.336-32,32-32s32,14.368,32,32v32h-64V176.02z M304,336.02H176v-96h128V336.02z"
})));

var _ref3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  d: "M501.984,161.172c-8.224-3.296-17.536,0.704-20.768,8.928l-9.568,23.936C444.16,91.668,350.88,16.02,240,16.02 c-132.352,0-240,107.648-240,240s107.648,240,240,240c64.096,0,124.352-24.96,169.728-70.304c6.24-6.24,6.24-16.384,0-22.624 s-16.384-6.24-22.624,0C347.776,442.388,295.52,464.02,240,464.02c-114.688,0-208-93.312-208-208s93.312-208,208-208 c99.872,0,183.488,70.784,203.424,164.8l-32.096-32.128c-6.24-6.24-16.384-6.24-22.624,0s-6.24,16.384,0,22.624l64,64 c0.352,0.352,0.832,0.48,1.216,0.8c1.216,1.024,2.464,2.016,3.936,2.624c1.92,0.864,4.032,1.28,6.144,1.28 c1.056,0,2.144-0.096,3.232-0.32c0.448-0.096,0.768-0.448,1.184-0.576c1.632-0.48,3.104-1.216,4.48-2.144 c0.608-0.416,1.216-0.704,1.76-1.184c1.76-1.6,3.232-3.488,4.16-5.728c0-0.032,0.032-0.064,0.064-0.096l32-80 C514.176,173.78,510.208,164.468,501.984,161.172z"
})));

var _ref4 = /*#__PURE__*/React.createElement("g", null);

var _ref5 = /*#__PURE__*/React.createElement("g", null);

var _ref6 = /*#__PURE__*/React.createElement("g", null);

var _ref7 = /*#__PURE__*/React.createElement("g", null);

var _ref8 = /*#__PURE__*/React.createElement("g", null);

var _ref9 = /*#__PURE__*/React.createElement("g", null);

var _ref10 = /*#__PURE__*/React.createElement("g", null);

var _ref11 = /*#__PURE__*/React.createElement("g", null);

var _ref12 = /*#__PURE__*/React.createElement("g", null);

var _ref13 = /*#__PURE__*/React.createElement("g", null);

var _ref14 = /*#__PURE__*/React.createElement("g", null);

var _ref15 = /*#__PURE__*/React.createElement("g", null);

var _ref16 = /*#__PURE__*/React.createElement("g", null);

var _ref17 = /*#__PURE__*/React.createElement("g", null);

var _ref18 = /*#__PURE__*/React.createElement("g", null);

function SvgRotationLock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512.04 512.04",
    style: {
      enableBackground: "new 0 0 512.04 512.04"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRotationLock);
export default __webpack_public_path__ + "static/media/rotation-lock.fb2f4187.svg";
export { ForwardRef as ReactComponent };